export const purchaseOrderStatus = [
  { label: "Approved", value: "ACCEPTED" },
  { label: "In Review", value: "IN_REVIEW" },
  { label: "Rejected", value: "REJECTED" },
  { label: "Draft", value: "DRAFT" },
];
